export const getAdministradorApiUrl: (pathname: string) => string = (pathname: string) => process.env.REACT_APP_SC_ADMINISTRADOR_API_URL + pathname;
export const getInfoIndividualOrientation = (pathname: string) => process.env.REACT_APP_SC_ADMINISTRADOR_API_URL + pathname
export const getOrquestadorApiUrl = (pathname: string) => process.env.REACT_APP_SC_ORQUESTADOR_API_URL + pathname

